import { z } from "zod";
import { LocationSchema } from "./location.schema";
import { dateIsAfter, datesAreEqual, datetimesAreEqual } from "@lib/util/date-ops";
import moment from "moment";
export const SearchCarsFormQuerySchema = z.object({
  pickUpLocation: LocationSchema.partial({
    country: true,
    value: true,
    iata: true,
    id: true,
    type: true,
    latitude: true,
    longitude: true
  }).or(LocationSchema).or(z.undefined()),
  dropOffLocation: LocationSchema.partial({
    country: true,
    value: true,
    iata: true,
    id: true,
    type: true,
    latitude: true,
    longitude: true
  }).or(LocationSchema).optional(),
  pickUpDate: z.date({
    coerce: true,
    invalid_type_error: "PICK_UP_DATE_IS_REQUIRED"
  }),
  dropOffDate: z.date({
    coerce: true,
    invalid_type_error: "DROP_OFF_DATE_IS_REQUIRED"
  }),
  pickUpTime: z.date({
    coerce: true,
    invalid_type_error: "PICK_UP_TIME_IS_REQUIRED"
  }),
  dropOffTime: z.date({
    coerce: true,
    invalid_type_error: "DROP_OFF_TIME_IS_REQUIRED"
  })
}).superRefine((data, ctx) => {
  if (!locationIsValid(data.pickUpLocation)) {
    ctx.addIssue({
      code: "custom",
      path: ["pickUpLocation"],
      message: "PICK_UP_LOCATION_IS_REQUIRED"
    });
  }

  // if (!locationIsValid(data?.dropOffLocation)) {
  //   ctx.addIssue({
  //     code: "custom",
  //     path: ["dropOffLocation"],
  //     message: "DROP_OFF_LOCATION_IS_REQUIRED",
  //   })
  // }

  if (!pickUpTimesAreValid(data.pickUpDate, data.dropOffDate, data.pickUpTime, data.dropOffTime)) {
    ctx.addIssue({
      code: "custom",
      path: ["dropOffTime"],
      message: "DROP_OFF_TIME_IS_INVALID"
    });
  }
});
const locationIsValid = location => {
  try {
    LocationSchema.parse(location);
    return location.id !== "disabled";
  } catch (error) {
    return false;
  }
};
const pickUpTimesAreValid = (pickUpDate, dropOffDate, pickUpTime, dropOffTime) => {
  const pickUpDateIsEqual = datesAreEqual(pickUpDate.toISOString(), dropOffDate.toISOString());
  if (pickUpDateIsEqual) {
    const minDropoffTime = moment(pickUpTime).add(2, "hours").set("seconds", 0).set("milliseconds", 0);
    const dropOffTimeIsValid = dateIsAfter(dropOffTime.toISOString(), minDropoffTime.toISOString()) || datetimesAreEqual(dropOffTime.toISOString(), minDropoffTime.toISOString());
    return dropOffTimeIsValid;
  } else {
    return true;
  }
};